import { getColor } from '@chakra-ui/theme-tools'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/alert.ts
export const Alert = {
  baseStyle: {
    container: {
      py: '0.5rem',
      lineHeight: '1.75',
      fontSize: 'sm',
      borderRadius: 'lg',
    },
  },
  variants: {
    subtle: (props) => ({
      container: { color: getColor(props.theme, `${props.colorScheme}.500`, props.colorScheme) },
    }),
  },
}
